import { defineMessages } from 'react-intl';

export default defineMessages({
  StatusDeviceDefaultPassword: {
    defaultMessage: 'Default password',
    id: 'status.device.defaultPassword',
  },
})
